<div class="label-group">
   <label class="label">{{title}}</label>
   <div *ngIf="data" [class.bottom-padding]="addBottomPadding" class="data">
      <span>{{data}}</span>
   </div>
   <div *ngIf="multilineData" [class.bottom-padding]="addBottomPadding"  class="multiline-data">
      <div class="data" *ngFor="let line of multilineData">
         <span>{{line}}</span>
      </div>
   </div>
</div>